import React from 'react'
import Select from 'react-select'
import ProfileMenu from '../Admin/MenuComponent/ProfileMenu'
import '../UserSignup/index.css'
import { ErrorScreen } from './ErrorScreen'
import './start.css'
import WaitingLoader from '../../../UI-components/Templates/WaitingLoader'
import { countries } from '../utils/commonUtilityFunctions'

const planOptions = window.REACT_APP_PLAN_LIST
  ? window.REACT_APP_PLAN_LIST.map(it => ({ label: it.name, value: it.planId }))
  : []

const profileItems = (firstName, familyName) => {
  return [
    {
      title: `${firstName}${familyName}`,
      root: true,
      label: 'User',
      submenu: [
        {
          title: 'Profile',
          url: '/profile',
          type: 'link',
          disabled: true
        },
        {
          title: 'Log out',
          type: 'link'
        }
      ]
    }
  ]
}

class Start extends React.Component {
  render() {
    const isperSisted =
      this.props.persisted &&
        this.props.persisted.userInformation !== null &&
        this.props.persisted.userInformation !== undefined
        ? this.props.persisted.userInformation
        : { name: 'U', family_name: '' }
    const firstName = isperSisted && isperSisted.name ? isperSisted.name.charAt(0) : 'U'
    const familyName = isperSisted && isperSisted.family_name ? isperSisted.family_name.charAt(0) : ''
    const userName = isperSisted && isperSisted.name ? isperSisted.name : 'User'
    const showCountryCodeStep = this.props.error !== null && this.props.showCountryCodeSelector
    const showPlanStep = this.props.error !== null && this.props.showPlanSelector
    const errorMessage = this.props.error

    return (
      <React.Fragment>
        <div className="start-org-creation">
          <div className="em-org-cr-flex">
            <div className="em-row org-logout">
              <div className="topicons">
                <ProfileMenu
                  disabled={false}
                  menuItems={profileItems(firstName, familyName)}
                  dispatch={() => { }}
                  showSwitch={() => { }}
                />
              </div>
            </div>
            {this.props.error !== null ? (
              showCountryCodeStep ? (
                <div className="em-row g-signup-comp welcome-country-step">
                  <div className="em-row t-component">
                    <h1>Hey {userName},</h1>
                    <h2>Please select your country to continue.</h2>
                    <div className="welcome-country-selector-wrap">
                      <Select
                        id="welcome-country-code"
                        classNamePrefix="welcome-country"
                        name="countryCode"
                        placeholder="Your Country*"
                        options={countries}
                        value={this.props.selectedCountryCode}
                        onChange={this.props.onCountryCodeChange}
                      />
                      {this.props.countryCodeError && (
                        <div className="t-error-text welcome-country-selector-error">
                          {this.props.countryCodeError}
                        </div>
                      )}
                    </div>
                    <button onClick={this.props.onResolve} className="em-btn welcome-country-continue">
                      Continue
                    </button>
                  </div>
                </div>
              ) : showPlanStep ? (
                <div className="em-row g-signup-comp welcome-country-step">
                  <div className="em-row t-component">
                    <h1>Hey {userName},</h1>
                    <h2>Please select a plan to continue.</h2>
                    <div className="welcome-country-selector-wrap">
                      <Select
                        id="welcome-plan-select"
                        classNamePrefix="welcome-country"
                        name="planId"
                        placeholder="Choose an Emly-Plan"
                        options={planOptions}
                        value={this.props.selectedPlan}
                        onChange={this.props.onPlanChange}
                      />
                      {this.props.planError && (
                        <div className="t-error-text welcome-country-selector-error">
                          {this.props.planError}
                        </div>
                      )}
                    </div>
                    <button onClick={this.props.onResolve} className="em-btn welcome-country-continue">
                      Continue
                    </button>
                  </div>
                </div>
              ) : (
                <ErrorScreen buttonText={'Retry'} error={errorMessage} onResolve={this.props.onResolve} containerClassName="welcome-error-container" />
              )
            ) : (
              <div className="start-org-content">
                <div className="centreLoadingSpinner">
                  <WaitingLoader message={`Welcome ${isperSisted && isperSisted.name}. Please wait, We are creating your organization!`} />
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default Start
